import React, { Component } from "react";
import styles from "./Products.module.css";
import ProductsHead from "./components/ProductsHead";
import ProductsBody from "./components/ProductsBody";

function Products() {
  return (
    <>
      <div className={`${styles.ProductsPageCont}`}>
        <div className={`${styles.ProductsPage} `}>
          <ProductsHead />
          <ProductsBody />
        </div>
      </div>
    </>
  );
}

export default Products;
